// ======================================================================
// File Name       : UserFrontImageAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/userfrontImage';
import { commonCallApi } from '../utils/ApiUtils';

export function getInitialImage(searchInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'userfront/GetImageSetting',
      data: searchInfo,
    }).then((result) => {
      dispatch({
        type: ActionTypes.USERFRONT_INITIAL_IMAGE_LIST,
        initialImageList: result,
      });
    });
  };
}

export function getInitialTopImage(searchInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'userfront/GetImageSetting',
      data: searchInfo,
    }).then((result) => {
      dispatch({
        type: ActionTypes.USERFRONT_INITIAL_TOP_IMAGE_LIST,
        initialImageList: result,
      });
    });
  };
}

export function editInitialImage(auth, listParams) {
  return (dispatch, getState) => {
    if (listParams && listParams.length) {
      const param = listParams[0];
      listParams.splice(0, 1);
      return dispatch(updateImageSetting(param)).then((error) => {
        if (!error) {
          return dispatch(editInitialImage(auth, listParams));
        }
        return error;
      });
    }
    return null;
  };
}

export function updateImageSetting(param) {
  return async (dispatch) => {
    try {
      await commonCallApi({
        path: 'userfront/UpdateImageSetting',
        data: param,
        muiltipart: 1,
      });
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function changeImageFile(nameKey, newFormValue) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.USERFRONT_CHANGE_IMAGE_FILE,
      data: { nameKey, newFormValue },
    });
  };
}

export function changeUserfrontImageData(data) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.USERFRONT_CHANGE_IMAGE_DATA,
      data,
    });
  };
}

export function getImageData(data) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.USERFRONT_GET_IMAGE_DATA,
      data,
    });
  };
}

export function updateDisplaySetting(param) {
  return async (dispatch) => {
    try {
      await commonCallApi({
        path: 'userfront/UpdateDisplaySetting',
        data: param,
      });
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function resetInitState() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.USERFRONT_RESET_INIT_STATE,
    });
  };
}
